<template>
  <div class="mall">
    <HeadBar /><!--顶部bar-->
    <!--顶部logo、检索-->
    <HeadNav /><!-- 顶部导航-->
    <!-- 筛选条件-->
    <TypeSelect
      @toSearch="typeSelectChange"
      :parentCates="parentCates"
      v-if="parentCates.length"
    />
    <div class="mall-con">
      <div class="searchBar">
        <div class="searchBar-inner flex flex-between">
          <SearchBarCircle
            :num="resultNum"
            v-model="keyword"
            @btnClick="searchBarClick"
            placeholder="请输入关键字"
          />
          <div class="flex">
            <div
              class="layout-grid"
              :class="{ active: layout == 'grid' }"
              @click="layout = 'grid'"
            >
              <i class="el-icon-s-grid"></i>
            </div>
            <div
              class="layout-line"
              :class="{ active: layout == 'line' }"
              @click="layout = 'line'"
            >
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
      <!--商品列表-->
      <div :class="`mall-good ${layout}`" v-loading="listLoading">
        <template v-if="goods.length && layout == 'line'">
          <Good
            v-for="(good, index) in goods"
            :key="index"
            :info="good"
            :unitMap="unitMap"
          />
        </template>
        <template v-else-if="goods.length && layout == 'grid'">
          <Item
            v-for="(good, index) in goods"
            :key="index"
            :info="good"
            :index="index + 1"
            :unitMap="unitMap"
          />
        </template>
        <div v-else class="no-data">暂无数据</div>
      </div>
      <!-- 分页-->
      <Pagination
        :total="totalItem"
        :page="page"
        @pageIndexChange="handlePageChange"
      />
    </div>
    <FootBar />
  </div>
</template>

<script>
import { mallList, queryKind } from "@/api/mall";
import Pagination from "@/components/Pagination/index";
import TypeSelect from "./components/TypeSelect";
import { SERVICE_UNIT_TYPE } from "@/constant/dict";
import Item from "./components/Item";
import Good from "./components/Good";
import SearchBarCircle from "@/components/SearchBarCircle/index";
export default {
  name: "Home",
  components: {
    TypeSelect,
    Good,
    Item,
    Pagination,
    SearchBarCircle,
  },
  data() {
    return {
      listLoading: false,
      resultNum: 0,
      goods: [],
      totalItem: 0,
      page: {
        pageIndex: 1,
        pageSize: 8,
      },
      keyword: "",
      parentCates: [], // 左边fixBar的类别数据
      unitMap: {},
      layout: "grid",
      queryParams: {},
    };
  },
  async created() {
    await this.getCategory();
    this.toSearch();
    this.getDicts();
  },
  methods: {
    async getDicts() {
      const units = await this.$store.dispatch(
        "getDictData",
        SERVICE_UNIT_TYPE
      );
      const unitMap = {};
      units.forEach((item) => {
        unitMap[item.dictValue] = item.dictLabel;
      });
      this.unitMap = unitMap;
    },
    handlePageChange(index) {
      this.page.pageIndex = index;
      this.toSearch();
    },
    // 获取类别
    async getCategory() {
      // 获取顶级分类
      const pData = await this.$axios.get(queryKind, {
        superCategoryId: 0,
      });
      this.parentCates = pData;
    },
    typeSelectChange(params) {
      this.page.pageIndex = 1;
      this.queryParams = params;
      this.toSearch();
    },
    async toSearch() {
      await this.$nextTick();
      const { types, parentType } = this.queryParams;
      // console.log(this.queryParams);
      const _params = {};
      if (types && types.length) {
        const brands = [];
        const citys = [];
        const serviceCategoryIds = [];
        types.forEach(({ title, id, name }) => {
          if (title === "类别") serviceCategoryIds.push(id);
          else if (title === "品牌") brands.push(name);
          else if (title === "地区") citys.push(name);
        });
        Object.assign(_params, { brands, citys, serviceCategoryIds });
      }
      if (!parentType) {
        const { cateId } = this.$route.query;
        const { serviceCategoryId } = this.parentCates[0];
        Object.assign(_params, {
          serviceCategorySuperId: cateId || serviceCategoryId,
        });
      } else {
        Object.assign(_params, {
          serviceCategorySuperId: parentType,
        });
      }
      this.listLoading = true;
      const { list, totalItem } = await this.$axios
        .post(mallList, {
          ...this.page,
          ..._params,
          keyword: this.keyword,
        })
        .finally(() => {
          this.listLoading = false;
        });

      this.goods = list;
      this.totalItem = totalItem;
      this.resultNum = list.length;
    },
    searchBarClick() {
      this.toSearch();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.mall {
  background: #f8f8f8;
  &-con {
    width: $max-width;
    margin: 0 auto;
    padding-bottom: 20px;
  }
  &-good {
    margin-bottom: 20px;
    &.grid {
      display: grid;
      grid-template-columns: repeat(2, calc(50% - 8px));
      gap: 16px;
    }
  }
}
.searchBar {
  margin-bottom: 30px;
  // padding: 5px 5px 5px 0;
  &-inner {
    box-sizing: border-box;
    margin: auto;
    background: #fff;
    width: $max-width;
    padding: 15px;
    border-radius: 0 0 6px 6px;
    /deep/ .el-input__inner {
      line-height: 37px;
      height: 37px;
    }
  }
  &-search {
    margin: 5px 70px 5px 0;
  }

  > div {
    width: $max-width;
  }
}
.layout {
  &-grid {
    background: #ffffff;
    padding: 10px 12px;
    font-size: 20px;
    color: #858585;
    &.active {
      i {
        color: #4483ff;
      }
    }
    i {
      cursor: pointer;
      &:hover {
        color: #4483ff;
      }
    }
  }
  &-line {
    padding: 17px 12px 0 12px;
    cursor: pointer;
    &:hover,
    &.active {
      div {
        background: #4483ff;
      }
    }
    div {
      height: 3px;
      width: 18px;
      background: #858585;
      border-radius: 20px;

      &:nth-child(2) {
        margin: 2px 0;
      }
    }
  }
}
</style>
